
export type RequiredField = 'SELFIE' | 'BIO' ;

export class Requirements {

  allowGuests: boolean ;

  emailSuffixes: string[] ;
  fields: RequiredField[] ;

  public constructor() {
    this.allowGuests = false ;
    this.emailSuffixes = [];
    this.fields = []
  }
}